import { createSelector } from '@reduxjs/toolkit';
import memoize from 'lodash/memoize';

const chartSelector = (state) => state.app.chart;
export const zoomLevelSelector = (state) => state.app.chart.zoomLevel;
export const rangeSelector = (state) => state.app.chart.range;
export const visibleAnnotationsSelector = (state) => state.app.chart.visibleAnnotations;
export const xScrollPositionSelector = (state) => state.app.chart.xScrollPosition;
export const availableZoomLevelsSelector = (state) => state.app.chart.availableZoomLevels;
export const maxScrollPositionSelector = (state) => state.app.chart.maxDataSize;
export const annotationsConfigSelector = (state) => state.app.chart.annotationsConfig;

export const isScrollAtStartSelector = createSelector(
    xScrollPositionSelector,
    (position) => position === 0
);
export const isScrollAtEndSelector = createSelector(
    maxScrollPositionSelector,
    zoomLevelSelector,
    xScrollPositionSelector,
    (max, zoomLevel, position) => position === max - zoomLevel
);

export const channelsSelector = createSelector(
    (state) => state.app.chart.channelsConfig,
    (state) => state.app.chart.channelsData,
    (config, data) =>
        data
            .map((channel) => ({ ...channel, ...config[channel.id] }))
            .sort((a, b) => (a.position > b.position ? 1 : -1))
);

const defaultQuickViewData = [];
const labelToChannelIdMapSelector = memoize((channelLabel) => (state) => {
    const channel = state.app.chart.channelsData.find(
        ({ label }) => label.toLowerCase().trim() === channelLabel.toLowerCase().trim()
    );

    if (channel === undefined) {
        return;
    }

    return channel.id;
});
export const getQuickViewChannelsData = (channelLabel) =>
    createSelector(
        (state) => state.app.chart.quickViewChannelsData,
        (state) => labelToChannelIdMapSelector(channelLabel)(state),
        (data, id) => data[id] || defaultQuickViewData
    );
